import {  Typography } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

import { BoosterType , Plan, UserBoosters } from '@/shared/types/Billing';

type RemovedBoostersListProps = {
  allBoosters: null | Partial<Record<BoosterType, { formattedPrice: string; price: number } & Plan>>;
  purchasedBoosters: null | Partial<UserBoosters>;
  selectedBoosters: Record<string, { isSelected: boolean; quantity: number }>;
}

export const RemovedBoostersList = ({ allBoosters, purchasedBoosters, selectedBoosters }: RemovedBoostersListProps) => {
  if (!allBoosters || !purchasedBoosters) return null;

  const removedBoosters = Object.entries(purchasedBoosters)
    .map(([type]) => {
      const boosterType = type as BoosterType;
      const isSelected = selectedBoosters[boosterType]?.isSelected;
      const booster = allBoosters[boosterType];

      if (!isSelected && booster) {
        return { booster, type };
      }
      return null;
    })
    .filter((item): item is { booster: { formattedPrice: string; price: number } & Plan; type: string } => item !== null);

  if (removedBoosters.length === 0) return null;

  return (
    <Stack mt={16}>
      {removedBoosters.map(({ booster, type }) => (
        <Stack  key={`${type}-remove`} alignItems="center" direction="row" justifyContent="space-between">
          <Typography color="grey.700" variant="body-2">
            {booster.name} remove
          </Typography>
          <Typography color="grey.700" variant="body-2">
            $0.00
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};
